import React from "react";
import "../WhyChoose.css";
import { NavLink } from "react-router-dom";

import {
    FiCheckCircle,
    FiShield,
    FiClock,
    FiUsers,
    FiTrendingUp,
    FiCpu,
    FiArrowRight,
} from "react-icons/fi";

const features = [
    {
        icon: <FiUsers />,
        title: "Experienced Team",
        desc: "Skilled professionals delivering reliable and innovative digital solutions."
    },
    {
        icon: <FiShield />,
        title: "Secure & Reliable",
        desc: "Enterprise-grade security and scalable architecture for every project."
    },
    {
        icon: <FiClock />,
        title: "On-Time Delivery",
        desc: "Efficient project management ensures timely delivery without compromising quality."
    },
    {
        icon: <FiTrendingUp />,
        title: "Growth Focused",
        desc: "Solutions designed to improve sales, efficiency, and business performance."
    },
    {
        icon: <FiCpu />,
        title: "Modern Technology",
        desc: "Built using the latest technologies for speed, scalability, and reliability."
    },
    {
        icon: <FiCheckCircle />,
        title: "Dedicated Support",
        desc: "Continuous technical support and maintenance to keep your business running."
    }
];

const WhyChoose = () => {
    return (

        <section className="home-why-section">

            <div className="container">

                <div className="home-why-wrapper">

                    {/* ================= LEFT CONTENT ================= */}

                    <div className="home-why-content">

                        <span className="home-why-badge">
                            Why Choose Kishancart
                        </span>

                        <h2>
                            Your Trusted Partner for
                            <span> Digital Transformation</span>
                        </h2>

                        <p>
                            At Kishancart Digital (OPC) Private Limited, we
                            combine innovation, technology, and industry
                            expertise to build powerful digital solutions.
                            Whether you're a startup, retailer, manufacturer,
                            or enterprise, we help you accelerate business
                            growth with scalable, secure, and future-ready
                            platforms.
                        </p>

                        <div className="home-why-points">

                            <div>
                                ✓ 100% Client-Focused Approach
                            </div>

                            <div>
                                ✓ Transparent Development Process
                            </div>

                            <div>
                                ✓ Long-Term Technical Partnership
                            </div>

                        </div>

                        <a
                            href="/contact"
                            className="home-why-btn"
                        >
                            Let's Work Together
                            <FiArrowRight />
                        </a>

                    </div>

                    {/* ================= RIGHT GRID ================= */}

                    <div className="home-why-grid">

                        {features.map((item, index) => (

                            <div
                                className="home-why-card"
                                key={index}
                            >

                                <div className="home-why-icon">
                                    {item.icon}
                                </div>

                                <h3>
                                    {item.title}
                                </h3>

                                <p>
                                    {item.desc}
                                </p>

                            </div>

                        ))}

                    </div>

                </div>

            </div>

        </section>

    );
};

export default WhyChoose;